import {
  Table,
  TableRow,
  TableHeader,
  TableBody,
  TableHeaderCell,
  TableCell,
  Text,
  useSpace,
  List,
  Stack,
} from 'braid-design-system';
import { SmartTextLink } from 'scoobie';

export const StepsTimelineTable = () => {
  const { grid } = useSpace();

  return (
    <Table label="Integration steps & timeline">
      <TableHeader>
        <TableRow>
          <TableHeaderCell colspan={2}>
            <Text>Step</Text>
          </TableHeaderCell>
          <TableHeaderCell>
            <Text>Typical duration</Text>
          </TableHeaderCell>
          <TableHeaderCell minWidth={grid * 64}>
            <Text>Tasks</Text>
          </TableHeaderCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        <TableRow>
          <TableCell>
            <Text>1</Text>
          </TableCell>
          <TableCell>
            <Text>
              <SmartTextLink href="#step-1-understand-scope">
                Understand scope
              </SmartTextLink>
            </Text>
          </TableCell>
          <TableCell>
            <Text>1 week</Text>
          </TableCell>
          <TableCell wrap>
            <List>
              <Text>Review documentation</Text>
              <Text>Finalise pre-migration planning</Text>
            </List>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <Text>2</Text>
          </TableCell>
          <TableCell>
            <Text>
              <SmartTextLink href="#step-2-request-access">
                Request access
              </SmartTextLink>
            </Text>
          </TableCell>
          <TableCell>
            <Text />
          </TableCell>
          <TableCell wrap>
            <List>
              <Text>
                Request access to start building and test your integration
              </Text>
            </List>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <Text>3</Text>
          </TableCell>
          <TableCell>
            <Text>
              <SmartTextLink href="#step-3-build--test">
                Build & test
              </SmartTextLink>
            </Text>
          </TableCell>
          <TableCell>
            <Stack space="small">
              <Stack space="xsmall">
                <Text>4 weeks</Text>
                <Text size="xsmall">Apply with SEEK</Text>
              </Stack>
              <Stack space="xsmall">
                <Text>5 weeks</Text>
                <Text size="xsmall">Apply with SEEK</Text>
                <Text size="xsmall">+ Ad Performance Panel</Text>
              </Stack>
            </Stack>
          </TableCell>
          <TableCell wrap>
            <List>
              <Text>Familiarise yourself with the Developer Dashboard</Text>
              <Text>Build required components</Text>
              <Text>Test end-to-end functionality</Text>
            </List>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <Text>4</Text>
          </TableCell>
          <TableCell>
            <Text>
              <SmartTextLink href="#step-4-certification">
                Certification
              </SmartTextLink>
            </Text>
          </TableCell>
          <TableCell>
            <Text>1–2 weeks</Text>
          </TableCell>
          <TableCell wrap>
            <List>
              <Text>
                Submit your integration for certification to ensure compliance
                with our requirements and technical standards
              </Text>
            </List>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <Text>5</Text>
          </TableCell>
          <TableCell>
            <Text>
              <SmartTextLink href="#step-5-release">Release</SmartTextLink>
            </Text>
          </TableCell>
          <TableCell>
            <Text>2–4 weeks</Text>
          </TableCell>
          <TableCell wrap>
            <List>
              <Text>
                Provide a list of hirers currently using Job Posting, Optimised
                Apply, link out, and/or Apply with SEEK so we can configure
                their access
              </Text>
              <Text>
                Develop and execute a customer release plan in consultation with
                SEEK
              </Text>
            </List>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
